import React, { useState } from 'react';
import Bouton from '../../../UI/Bouton/Bouton';
import { stringOrEmptyString } from '../../../../ressources/functionJS/stringOrEmptyString';
import * as glossaire_type_objets_vue from '../../../../ressources/glossaires/glossaire_type_objets_vue';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';
import { GiCctvCamera, GiSpeaker, IoMdImages } from 'react-icons/all';
import Iframe from 'react-iframe';
import { setUrlPathFromDomain } from '../../../../services/utils/utils';

const ObjetTexte = (props) => {
  const [viewobjJsonContent, setViewobjJsonContent] = useState(null);
  const [attenteRecupFichierJson, setAttenteRecupFichierJson] = useState(false);
  const { viewobj_json_content } = props;

  let representation_vue = <Bouton>{props.objetAAfficher.name}</Bouton>;
  if (props.objetAAfficher !== undefined) {
    if (
      viewobjJsonContent === null &&
      props.objetAAfficher.viewobj_path !== undefined &&
      stringOrEmptyString(props.objetAAfficher.viewobj_path) !== '' &&
      !attenteRecupFichierJson &&
      viewobj_json_content === undefined
    ) {
      try {
        let cheminURL = setUrlPathFromDomain(
          props.objetAAfficher.viewobj_path,
          'https://' +
            document.domain +
            props.objetAAfficher.viewobj_path.slice(
              1,
              props.objetAAfficher.viewobj_path.length
            )
        );
        fetch(cheminURL + '?varget' + Math.random())
          .then((res) => res.json())
          .then((data) => {
            setViewobjJsonContent(data);
            setAttenteRecupFichierJson(false);
          })
          .catch((e) => console.error('error: ', e));
      } catch (e) {
        setViewobjJsonContent(null);
        setAttenteRecupFichierJson(false);
        console.error('error', e);
      }
    } else if (
      viewobjJsonContent !== null &&
      viewobjJsonContent.type_de_representation !== undefined
    ) {
      switch (viewobjJsonContent.type_de_representation) {
        case glossaire_type_objets_vue.bouton_lien_audio:
          representation_vue = (
            <button
              onClick={() =>
                window.open(
                  viewobjJsonContent.lien_fichier !== undefined
                    ? viewobjJsonContent.lien_fichier
                    : props.objetAAfficher.name,
                  '_blank',
                  `toolbar=no,scrollbars=yes,dependent=yes,top=0,left=0,innerWidth=${window.screen.availWidth},innerHeight=${window.screen.availHeight}`
                )
              }
              className={[s.btn, s.btn_sm].join(' ')}
              style={{
                ...viewobjJsonContent.styleMainDiv,
              }}
              disabled={viewobjJsonContent.disabled === true}
            >
              <GiSpeaker />
            </button>
          );
          break;
        case glossaire_type_objets_vue.bouton_lien_video:
          representation_vue = (
            <button
              onClick={() =>
                window.open(
                  viewobjJsonContent.lien_fichier !== undefined
                    ? viewobjJsonContent.lien_fichier
                    : props.objetAAfficher.name,
                  '_blank',
                  `toolbar=no,scrollbars=yes,dependent=yes,top=0,left=0,innerWidth=${window.screen.availWidth},innerHeight=${window.screen.availHeight}`
                )
              }
              className={[s.btn, s.btn_sm].join(' ')}
              style={{
                ...viewobjJsonContent.styleMainDiv,
              }}
              disabled={viewobjJsonContent.disabled === true}
            >
              <GiCctvCamera />
            </button>
          );
          break;
        case glossaire_type_objets_vue.bouton_lien_image:
          representation_vue = (
            <button
              onClick={() =>
                window.open(
                  viewobjJsonContent.lien_fichier !== undefined
                    ? viewobjJsonContent.lien_fichier
                    : props.objetAAfficher.name,
                  '_blank',
                  `toolbar=no,scrollbars=yes,dependent=yes,top=0,left=0,innerWidth=${window.screen.availWidth},innerHeight=${window.screen.availHeight}`
                )
              }
              className={[s.btn, s.btn_sm].join(' ')}
              style={{
                ...viewobjJsonContent.styleMainDiv,
              }}
              disabled={viewobjJsonContent.disabled === true}
            >
              {viewobjJsonContent.lien_bouton_image === undefined ? (
                <IoMdImages />
              ) : (
                <img
                  alt={'lien bouton'}
                  src={viewobjJsonContent.lien_bouton_image}
                  style={{
                    ...viewobjJsonContent.styleBoutonImage,
                  }}
                />
              )}
            </button>
          );
          break;
        case glossaire_type_objets_vue.iframe:
          representation_vue = (
            <Iframe
              url={viewobjJsonContent.url}
              id=""
              className=""
              styles={{ ...viewobjJsonContent.iframe_style }}
              allow="fullscreen"
              display="block"
              frameborder="0"
              width="700"
              height="500"
              position="relative"
              {...viewobjJsonContent.iframe_props}
            />
          );
          break;
        case glossaire_type_objets_vue.texte_div:
          representation_vue = (
            <div
              id=""
              style={{
                ...viewobjJsonContent.main_style,
              }}
              {...viewobjJsonContent.texte_div_props}
            >
              {viewobjJsonContent.texte}
            </div>
          );
          break;
        default:
          representation_vue = <div>Défaut</div>;
          break;
      }
    }
  }
  return representation_vue;
};

export default ObjetTexte;
